/* VENOR picker — skate type, colourway and size selection.
 *
 * The markup is fully server-rendered; this file only moves state between the
 * controls the shopper sees and the <select> the form actually submits. Nothing
 * is built in JS, so there is no layout shift and the page still buys without it.
 *
 * Sizes are identified by position, never by their label: option values sync from
 * TRAEDE and are translated per market, so "21,8-24,3 cm (EU 34-37)" is a
 * different string on every storefront. Position is not.
 */
(function () {
  var root = document.getElementById('VenorPicker');
  if (!root) return;

  /* ── Type switch ──────────────────────────────────────────────────────── */

  var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-vnp-tab]'));

  function showPanel(key) {
    for (var i = 0; i < tabs.length; i++) {
      var isOn = tabs[i].getAttribute('data-vnp-tab') === key;
      tabs[i].classList.toggle('vnp__tab--on', isOn);
      tabs[i].setAttribute('aria-selected', isOn ? 'true' : 'false');
      tabs[i].tabIndex = isOn ? 0 : -1;
    }
    var panels = root.querySelectorAll('[data-vnp-panel]');
    for (var j = 0; j < panels.length; j++) {
      panels[j].hidden = panels[j].getAttribute('data-vnp-panel') !== key;
    }
  }

  for (var t = 0; t < tabs.length; t++) {
    tabs[t].addEventListener('click', function (event) {
      showPanel(event.currentTarget.getAttribute('data-vnp-tab'));
    });
  }

  /* Left/right arrows move between tabs, which is what a tablist owes a keyboard
     user. Home/End are not wired up: with two tabs they would do nothing new. */
  root.addEventListener('keydown', function (event) {
    if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
    var current = event.target.closest ? event.target.closest('[data-vnp-tab]') : null;
    if (!current) return;
    var index = tabs.indexOf(current);
    if (index === -1) return;
    event.preventDefault();
    var next = tabs[(index + (event.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
    showPanel(next.getAttribute('data-vnp-tab'));
    next.focus();
  });

  /* ── Sticky buy bar ───────────────────────────────────────────────────
     Once the buy button leaves the screen the page offers no way to purchase for
     the rest of its length. This mirrors whatever the visible panel currently has
     chosen and keeps buying one tap away. Rendered once and pointed at the active
     panel, rather than one bar per panel fighting for the same space. */

  /* Queried from the document, not from root: the bar is fixed-position and sits
     as a sibling of the section, so a lookup scoped to the section finds nothing. */
  var sticky = document.querySelector('[data-vnp-sticky]');
  var stickyImg = document.querySelector('[data-vnp-sticky-img]');
  var stickyImg2 = document.querySelector('[data-vnp-sticky-img2]');
  var stickyName = document.querySelector('[data-vnp-sticky-name]');
  var stickyMeta = document.querySelector('[data-vnp-sticky-meta]');
  var stickyCta = document.querySelector('[data-vnp-sticky-cta]');

  function activePanel() {
    return root.querySelector('[data-vnp-panel]:not([hidden])');
  }

  window.venorSyncSticky = function () {
    if (!sticky) return;
    var panel = activePanel();
    if (!panel) return;

    var shot = panel.querySelector('.vnp__shot--on img');
    var name = panel.querySelector('[data-vnp-chosen-color]');
    var size = panel.querySelector('[data-vnp-sizes]:not([hidden]) [aria-pressed="true"]');
    var add = panel.querySelector('[data-vnp-add]');
    var label = panel.querySelector('[data-vnp-add-label]');

    if (shot && stickyImg) stickyImg.src = shot.currentSrc || shot.src;
    if (stickyName && name) stickyName.textContent = name.textContent;

    /* Read the add-on state from the DOM rather than from the panel's closure, so
       the bar stays a mirror of what is on screen. */
    var pairOn = !!panel.querySelector('[data-vnp-opt="pair"].vnp__opt--on');
    var addShot = panel.querySelector('[data-venor-inline] .vpp__shot--on img');
    var addName = panel.querySelector('[data-venor-inline] [data-vpp-name]');

    if (stickyImg2) {
      if (pairOn && addShot) {
        stickyImg2.src = addShot.currentSrc || addShot.src;
        stickyImg2.hidden = false;
      } else {
        stickyImg2.hidden = true;
      }
    }

    if (stickyMeta) {
      var parts = [];
      if (size) parts.push(size.textContent.trim());
      else if (add) parts.push(add.getAttribute('data-vnp-choose-label') || '');
      /* Name the second item, so the bar says what the higher total is for. */
      if (pairOn) {
        var optName = panel.querySelector('[data-vnp-opt="pair"] .vnp__opt-name');
        if (optName) parts.push(optName.textContent.trim());
        else if (addName) parts.push(addName.textContent.trim());
      }
      stickyMeta.textContent = parts.filter(Boolean).join(' · ');
    }
    /* The bar carries the same label as the real button, so the total it shows is
       the same total the button would charge. */
    if (stickyCta && label) stickyCta.textContent = label.textContent;
  };

  if (sticky && stickyCta) {
    stickyCta.addEventListener('click', function () {
      var panel = activePanel();
      if (!panel) return;
      var add = panel.querySelector('[data-vnp-add]');
      if (add && !add.disabled) {
        add.click();
        return;
      }
      /* No size chosen yet — send them to the choice rather than failing. */
      var sizes = panel.querySelector('[data-vnp-sizes]:not([hidden])');
      (sizes || panel).scrollIntoView({ block: 'center', behavior: 'smooth' });
    });

    /* Shown only once the real buy button is off screen. */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          var past = !entries[i].isIntersecting && entries[i].boundingClientRect.top < 0;
          sticky.classList.toggle('vnp__sticky--on', past);
          sticky.hidden = !past;
          if (past) window.venorSyncSticky();
        }
      }, { threshold: 0 });
      var buy = root.querySelector('.vnp__buy');
      if (buy) io.observe(buy);
    }
  }

  /* ── Per-panel selection ──────────────────────────────────────────────── */

  var panels = root.querySelectorAll('[data-vnp-panel]');

  for (var p = 0; p < panels.length; p++) setupPanel(panels[p]);

  function setupPanel(panel) {
    var swatches = panel.querySelectorAll('[data-vnp-color]');
    /* The size buttons carry the price as data, so the output element needs an
       attribute of its own — [data-vnp-price] would match the first button and
       overwrite its label. */
    var priceEl = panel.querySelector('[data-vnp-price-out]');
    var select = panel.querySelector('[data-vnp-select]');
    var addBtn = panel.querySelector('[data-vnp-add]');
    var addLabel = panel.querySelector('[data-vnp-add-label]');
    var chosenColor = panel.querySelector('[data-vnp-chosen-color]');
    if (!select || !addBtn) return;

    var readyLabel = addLabel ? addLabel.textContent.trim() : '';
    var waitingLabel = addBtn.getAttribute('data-vnp-choose-label') || readyLabel;

    /* ── The protection add-on ─────────────────────────────────────────── */

    var mount = panel.querySelector('[data-venor-mount]');
    var bundle = panel.querySelector('[data-vnp-bundle]');
    var opts = bundle ? [].slice.call(bundle.querySelectorAll('[data-vnp-opt]')) : [];
    var optSub = panel.querySelector('[data-vnp-opt-sub]');
    var shipLine = panel.querySelector('[data-vnp-addon-ship]');
    var totalSingle = addBtn.getAttribute('data-vnp-total-single') || '';
    var totalPair = addBtn.getAttribute('data-vnp-total-pair') || '';
    var addonVariant = null;

    /* Skates alone is the default. Pre-selecting the pair pre-ticks 179 kr of
       extras the shopper never asked for — the add-on has to be chosen, not
       un-chosen. The card is still first-class and one tap away. */
    var chosenOpt = 'single';

    function addonOn() {
      return Boolean(chosenOpt === 'pair' && addonVariant);
    }

    function paintOpts() {
      for (var i = 0; i < opts.length; i++) {
        var on = opts[i].getAttribute('data-vnp-opt') === chosenOpt;
        opts[i].classList.toggle('vnp__opt--on', on);
        opts[i].setAttribute('aria-checked', on ? 'true' : 'false');
      }
      if (shipLine) shipLine.hidden = !addonOn();
      /* The colour and size chooser belongs to the pair, so it appears with it.
         The mount itself stays in the document either way — it has to render to
         report a variant back, which is what reveals the two cards at all. */
      if (mount) mount.hidden = chosenOpt !== 'pair';
    }

    /* Both totals were rendered server-side in this market's currency; this only
       picks between them. Formatting money here would lose the theme's EUR
       symbol-placement correction. */
    function paintTotal() {
      if (!addLabel) return;
      if (addBtn.disabled) {
        addLabel.textContent = waitingLabel;
        return;
      }
      var total = addonOn() ? totalPair : totalSingle;
      addLabel.textContent = total ? readyLabel + ' · ' + total : readyLabel;

      /* Name what the total covers, right above the button. On desktop the offer
         cards sit in the other column, so without this the button reads 778 under
         a product priced at 599. */
      var sum = panel.querySelector('[data-vnp-buy-sum]');
      if (sum) {
        var chosenCard = panel.querySelector('[data-vnp-opt="' + chosenOpt + '"] .vnp__opt-name');
        sum.textContent = bundle && !bundle.hidden && chosenCard ? chosenCard.textContent.trim() : '';
      }
      paintOpts();
      if (typeof window.venorSyncSticky === 'function') window.venorSyncSticky();
    }

    if (mount) {
      mount.addEventListener('venor:addon', function (event) {
        addonVariant = event.detail ? event.detail.variantId : null;
        if (bundle) bundle.hidden = !addonVariant;
        if (optSub && event.detail && event.detail.priceText) {
          optSub.textContent = '+ ' + event.detail.priceText;
        }
        if (!addonVariant) chosenOpt = 'single';
        /* Before paintTotal, not after: paintTotal returns early while no size
           is chosen, and paintOpts is what hides the set's colour and size
           chooser. With the pair as the default that early return was harmless
           — the chooser was meant to be visible. With skates alone as the
           default it left the chooser on screen under an unselected card. */
        paintOpts();
        paintTotal();
      });
    }

    for (var o = 0; o < opts.length; o++) {
      opts[o].addEventListener('click', function (event) {
        chosenOpt = event.currentTarget.getAttribute('data-vnp-opt');
        /* Repaint the cards here rather than leaving it to paintTotal, which
           returns early while the buy button is still waiting for a size. Before
           this, tapping "skates only" with no size chosen set the state but
           moved nothing on screen: the pair is preselected, so the shopper
           trying to decline the add-on appeared to be prevented from doing it. */
        paintOpts();
        paintTotal();
      });
    }

    /* Keep the set matched to whatever skate is currently chosen. Size is mapped
       by position, never by label: the four skate ranges collapse onto the two
       protection ages, smaller two to the younger set. */
    function syncAddon() {
      if (!mount || typeof window.venorSyncUpsell !== 'function') return;
      var swatchOn = panel.querySelector('[data-vnp-color][aria-pressed="true"]');
      var sizeOn = panel.querySelector('[data-vnp-sizes]:not([hidden]) [aria-pressed="true"]');
      mount.dataset.venorColorName = swatchOn ? swatchOn.getAttribute('data-vnp-color-name') || '' : '';
      var idx = sizeOn ? Number(sizeOn.getAttribute('data-vnp-size-index')) : 0;
      mount.dataset.venorSizeIndex = idx > 1 ? '1' : '0';
      window.venorSyncUpsell(mount);
    }

    function activeSizes() {
      return panel.querySelector('[data-vnp-sizes]:not([hidden])');
    }

    function selectedSizeIndex() {
      var group = activeSizes();
      if (!group) return null;
      var on = group.querySelector('[aria-pressed="true"]');
      return on ? on.getAttribute('data-vnp-size-index') : null;
    }

    function setBuyState(button) {
      if (button) {
        select.value = button.getAttribute('data-vnp-variant');
        if (priceEl) priceEl.textContent = button.getAttribute('data-vnp-price') || '';
        addBtn.disabled = false;
        paintTotal();
      } else {
        addBtn.disabled = true;
        if (addLabel) addLabel.textContent = waitingLabel;
        if (shipLine) shipLine.hidden = true;
        /* Keep a price on screen rather than blanking it: the shopper still needs
           to know what the skate costs while choosing a size. */
        var group = activeSizes();
        var firstLive = group ? group.querySelector('[data-vnp-variant]:not([disabled])') : null;
        if (priceEl && firstLive) priceEl.textContent = firstLive.getAttribute('data-vnp-price') || '';
      }
    }

    function chooseSize(button) {
      var group = activeSizes();
      if (!group) return;
      var buttons = group.querySelectorAll('[data-vnp-variant]');
      for (var i = 0; i < buttons.length; i++) {
        buttons[i].setAttribute('aria-pressed', buttons[i] === button ? 'true' : 'false');
      }
      setBuyState(button);
    }

    function chooseColor(swatch, keepSizeIndex) {
      var handle = swatch.getAttribute('data-vnp-color');

      for (var i = 0; i < swatches.length; i++) {
        var isOn = swatches[i] === swatch;
        swatches[i].classList.toggle('vnp__swatch--on', isOn);
        swatches[i].setAttribute('aria-pressed', isOn ? 'true' : 'false');
      }

      var shots = panel.querySelectorAll('[data-vnp-shot]');
      for (var s = 0; s < shots.length; s++) {
        shots[s].classList.toggle('vnp__shot--on', shots[s].getAttribute('data-vnp-shot') === handle);
      }

      var groups = panel.querySelectorAll('[data-vnp-sizes]');
      for (var g = 0; g < groups.length; g++) {
        groups[g].hidden = groups[g].getAttribute('data-vnp-sizes') !== handle;
      }

      /* The LED accent follows the colourway. A colour with no mapped tint clears
         the property so the section falls back to its default accent. */
      if (chosenColor) chosenColor.textContent = swatch.getAttribute('data-vnp-color-name') || '';

      /* Carry the size across a colour change when that size exists and is in
         stock in the new colourway — re-picking an already-made choice is friction. */
      var carried = null;
      if (keepSizeIndex !== null && keepSizeIndex !== undefined) {
        var newGroup = activeSizes();
        if (newGroup) {
          var match = newGroup.querySelector('[data-vnp-size-index="' + keepSizeIndex + '"]');
          if (match && !match.disabled) carried = match;
        }
      }
      chooseSize(carried);
      syncAddon();
      if (typeof window.venorSyncSticky === 'function') window.venorSyncSticky();
    }

    for (var c = 0; c < swatches.length; c++) {
      swatches[c].addEventListener('click', function (event) {
        chooseColor(event.currentTarget, selectedSizeIndex());
      });
    }

    panel.addEventListener('click', function (event) {
      var button = event.target.closest ? event.target.closest('[data-vnp-variant]') : null;
      if (!button || button.disabled) return;
      chooseSize(button);
      syncAddon();
    });

    /* Initial paint: first colourway, no size yet. */
    if (swatches.length) chooseColor(swatches[0], null);

    /* ── Add to cart ───────────────────────────────────────────────────── */

    var form = panel.querySelector('[data-vnp-form]');
    if (!form) return;

    form.addEventListener('submit', function (event) {
      /* Without the drawer helpers there is nothing to enhance — let the browser
         POST the form and land on the cart page. */
      if (typeof window.refreshCartDrawer !== 'function') return;
      if (!select.value) return;

      event.preventDefault();
      addBtn.disabled = true;

      /* Skate and set go in one request. /cart/add.js takes an items array, so
         this stays a standard Shopify add and the store's customer-events pixel
         still reports both lines without any tracking code of our own. */
      var items = [{ id: Number(select.value), quantity: 1 }];
      if (addonOn()) items.push({ id: Number(addonVariant), quantity: 1 });

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items }),
      })
        .then(function (response) {
          if (!response.ok) throw new Error('add ' + response.status);
          return window.refreshCartDrawer({ open: true });
        })
        .then(function () {
          addBtn.disabled = false;
          /* The set is in the cart now, so stop offering it. */
          if (addonOn()) {
            chosenOpt = 'single';
            if (bundle) bundle.hidden = true;
          }
          paintTotal();
        })
        .catch(function () {
          /* Fall back to the real form post so the shopper is never stuck. */
          form.submit();
        });
    });
  }
})();
